import {
  SHOW_PREFERENCES,
  SAVE_PREFERENCES,
  HIDE_PREFERENCES,
  EDIT_PREFERENCES
} from '../actions/types';
import { getPreferences, setPreferences } from "../preferences"

export const preferencesRequest = (state = {}, action) => {
  switch (action.type) {
    case SHOW_PREFERENCES:      
      return Object.assign({}, state, {
        visible: true,
        current: getPreferences(),
        edit: getPreferences()
      });
    case HIDE_PREFERENCES:
      return Object.assign({}, state, {
        visible: false,
      });
    case EDIT_PREFERENCES:
       return Object.assign({}, state, {
         edit: action.data
       });
      case SAVE_PREFERENCES:
        setPreferences(action.data)
        return Object.assign({}, state, {
          visible: false,
          current: action.data
        });
    default:
      return state;
  }
};
